import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class EtiquetaPreguntaService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
    ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'etiqueta-pregunta'].join('/');
  }

  public consultarPorOrganizacion(organizacionId) {
    return this.http
    .get(`${this.ApiUrl}/organizacion/${organizacionId}`)
    .map(res => res.json());
  }

  public consultarPorOrganizacionRepo(organizacionId) {
    return this.http
    .get(`${this.ApiUrl}/organizacion-repo/${organizacionId}`)
    .map(res => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/services/etiqueta-pregunta/etiqueta-pregunta.service.ts